module.exports = __webpack_public_path__ + "img/forest.b8c09701.jpg";